import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react';
import ChevronDown from './Accordion/ChevronDown';
import { useState } from 'react';
import { getPinForImage } from './mapUtils';
import { useMapStore } from './store';

function MapLegend() {
  const [open, setOpen] = useState(false)
  const { isDesktop } = useMapStore();
  if(isDesktop) {
    return (
      <div className="text-white flex flex-wrap items-center justify-between w-full p-8 gap-y-8"  role="complementary" aria-label="Map legend">
        <h2 className='h3 text-white flex-none'>Map Legend:</h2>
        <div className="flex gap-8">
          <Legend />
        </div>
      </div>
    )
  }
  return (
    <Disclosure as="div" className="text-white block"  role="complementary" aria-label="Map legend">
      <DisclosureButton
        className="group flex w-full items-center justify-between p-8"
        style={{ minWidth: 280 }}
        onClick={() => { setOpen(currentState => !currentState) }}
      >
        <span className="h3 text-white text-nowrap group-data-[hover]:text-white/80">
          Map Legend
        </span>
        <div className='inline'><ChevronDown open={open} fill="#fff" /></div>
      </DisclosureButton>
      <DisclosurePanel className="flex flex-wrap gap-8 p-8">
        <Legend isMobile={true} />
      </DisclosurePanel>
    </Disclosure>
  )
}

function Legend({ isMobile }: { isMobile?: boolean }) {
  return (
    <>
      <div className='flex flex-col md:flex-row items-center gap-8'>
        <div className='inline-flex items-center gap-4 max-w-[170px] w-full'>
          <img src={getPinForImage("Active")} alt="Current Water Outage pin" />
          <p className='align-middle'>Current Water Outage</p>
        </div>
        <div className={`inline-flex items-center gap-4 ${isMobile ? 'max-w-[170px]' : 'max-w-[190px]'} w-full`}>
          <img src={getPinForImage("Completed")} alt="Recently Completed Works pin" />
          <p className='align-middle'>Recently Completed Works</p>
        </div>
      </div>
      <div className='flex flex-col md:flex-row items-center gap-12'>
        <div className='inline-flex items-center gap-4 max-w-[170px] w-full'>
          <img src={getPinForImage("Registered")} alt="Upcoming Water Outage pin" />
          <p className='align-middle'>Upcoming Water Outage</p>
        </div>
        <div className='inline-flex items-center gap-4 max-w-[170px] w-full'>
          <img src={getPinForImage("Major")} alt="Major Works" />
          <p className='align-middle'>Major Works</p>
        </div>
      </div>
    </>
  )
}

export default MapLegend;
